/**
 * Return a promise that's cancellable which is a wrapper around the original promise.
 *
 * @param {Promise} promise Original promise
 * @return {{promise: Promise, cancel: (function())}}
 */
export default function makePromiseCancelable(promise) {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => (hasCanceled_ ? reject({isCanceled: true}) : resolve(val)));
    promise.catch(error => (hasCanceled_ ? reject({isCanceled: true}) : reject(error)));
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
}
